import "./slider.css";
// import img1 from "../images/speak.png"
// import pdf from "../posters/ACMC-NurUnal.pdf"
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
function CardCurrent(props){

    return(
        <div className="card__content">
            <article className="card__article">
                 <div className="card__image">
                     <img src={props.img} alt="" className="card__img" width="450px"></img>
                     {/* <div className="card__shadow"></div> */}
                 </div>
                 <div className="card__data">
                     <h3 className="card__name"> {props.name}</h3>
                     <h4 className="card__desc"> {props.date}</h4>
                     <a href={props.pdf} target="_blank" className="card__button" rel="noreferrer">VIEW POSTER</a>
                 </div>
             </article>
        </div>
        // <div className="card__name">{props.name}</div>
    )
}

export default CardCurrent


